import Layout from '@/views/layout'

export default [
  {
    path: '/vipCard',
    name: 'vipCard',
    redirect: '/vipCard/cardManage',
    component: Layout,
    meta: {
      title: '会员储值卡',
      icon: 'order.png',
      index: 7
    },
    children: [
      {
        path: 'cardManage',
        name: 'cardManage',
        meta: {
          title: '储值卡管理'
        },
        component: () => import('@/views/vipCard/cardManage')
      },
      {
        path: 'addCard',
        name: 'addCard',
        meta: {
          title: '新增储值卡'
        },
        hidden: true,
        component: () => import('@/views/vipCard/subPage/addCard')
      },
      {
        path: 'vipPriceManage',
        name: 'vipPriceManage',
        meta: {
          title: '会员价管理'
        },
        component: () => import('@/views/vipCard/vipPriceManage')
      },
      {
        path: 'vipManage',
        name: 'vipManage',
        meta: {
          title: '储值会员管理'
        },
        component: () => import('@/views/vipCard/vipManage/index')
      },
      {
        path: 'orderDetails',
        name: 'orderDetails',
        hidden: true,
        meta: {
          title: '订单详情'
        },
        component: () => import('@/views/vipCard/vipManage/orderDetails')
      },
      {
        path: 'revenue',
        name: 'revenue',
        hidden: true,
        meta: {
          title: '收支明细'
        },
        component: () => import('@/views/vipCard/vipManage/revenue')
      },
      {
        path: 'savingDetail',
        name: 'savingDetail',
        meta: {
          title: '储值明细'
        },
        component: () => import('@/views/vipCard/savingDetail')
      }
    ]
  }
]